import { createAction } from '@reduxjs/toolkit'
import { Battery } from '../../../shared/types/battery'
import { CartItem } from './types'

/**
 * Actions do módulo Cart
 */
export const cartActions = {
  // Add item to cart (willReturnScrap: quando informado, atualiza a preferência de sucata)
  addItem: createAction<{ product: Battery; quantity?: number; showToast?: boolean; willReturnScrap?: boolean }>('cart/addItem'),
  // Definir preferência de devolução de sucata (Campinas)
  setScrapPreference: createAction<boolean | null>('cart/setScrapPreference'),
  
  // Remove item from cart
  removeItem: createAction<string>('cart/removeItem'),
  
  // Update item quantity
  updateQuantity: createAction<{ id: string; quantity: number }>('cart/updateQuantity'),
  // Atualizar preferência de sucata de um item (por productId)
  updateItemScrapPreference: createAction<{ productId: string; willReturnScrap: boolean }>('cart/updateItemScrapPreference'),
  
  // Clear cart
  clearCart: createAction('cart/clearCart'),
  
  // Toggle cart open/close
  toggleCart: createAction('cart/toggleCart'),
  
  // Open cart
  openCart: createAction('cart/openCart'),
  
  // Close cart
  closeCart: createAction('cart/closeCart'),
  
  // Load cart from storage
  loadCart: createAction<CartItem[]>('cart/loadCart'),
}

